<template>
  <div class="app-container">
    <el-card class="box-card">
      <div class="filter-container">
        <el-form :model="query" ref="queryForm" :inline="true">
          <el-form-item label="问题内容：">
            <el-input v-model="query.questionContent" placeholder="请输入问题内容" clearable size="small" />
          </el-form-item>
          <el-form-item label="用户姓名：">
            <el-input v-model="query.userName" placeholder="请输入姓名" clearable size="small" />
          </el-form-item>
          <el-form-item label="用户手机号：">
            <el-input v-model="query.userPho" placeholder="请输入手机号" clearable size="small" />
          </el-form-item>
          <el-form-item label="身份：">
            <el-select v-model="query.isEnable" placeholder="请选择" clearable size="small">
              <el-option label="启用" :value="1"></el-option>
              <el-option label="禁用" :value="0"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="handleQuery" size="mini">搜索</el-button>
            <el-button type="info" @click="handleFilter" plain size="mini">重置</el-button>
          </el-form-item>
        </el-form>
      </div>
    </el-card>
    <el-card class="box-card mt10">
      <el-tabs v-model="activeName" @tab-click="handleClick">
        <el-tab-pane label="待审核" name="0"></el-tab-pane>
        <el-tab-pane label="合格" name="1"></el-tab-pane>
        <el-tab-pane label="不合格" name="2"></el-tab-pane>
      </el-tabs>
      <el-table v-loading="listLoading" :data="list" @selection-change="selectionChange" @sort-change="sortChange">
        <el-table-column label="用户信息" prop="name" align="center" width="200">
          <template slot-scope="{row}">
            {{row.realName}}{{row.identity?'('+row.identity+')':''}}<br />{{row.userPho}}
          </template>
        </el-table-column>
        <el-table-column label="问题内容" prop="courseScenarioExercisePO.questionContent" align="center" show-overflow-tooltip />
        <el-table-column label="图片" prop="" align="center">
          <template slot-scope="{row}">
            <el-image style="width: 50px; height: 50px" v-if="row.courseScenarioExercisePO.imgUrl" :src="row.courseScenarioExercisePO.imgUrl" :preview-src-list="[row.courseScenarioExercisePO.imgUrl]"></el-image>
          </template>
        </el-table-column>
        <el-table-column label="回答" prop="correctAnswer" align="center" width="320">
          <template slot-scope="{row}">
            <audio :src="row.answerContent" controls></audio>
          </template>
        </el-table-column>
        <el-table-column label="回答时间" prop="createdTime" sortable="custom" align="center" width="200" />
        <el-table-column label="操作" align="center" width="200" fixed="right">
          <template slot-scope="{row}">
            <el-button type="text" @click="handleState(row,1)" v-if="activeName === '0'" v-hasPermi="['course:sceneRecords:examine']">合格</el-button>
            <el-button type="text" @click="handleState(row,2)" v-if="activeName === '0'" v-hasPermi="['course:sceneRecords:examine']">不合格</el-button>
          </template>
        </el-table-column>
      </el-table>
      <pagination v-show="total>0" :total="total" :pageNo.sync="query.pageNo" :pageSize.sync="query.pageSize" @pagination="doQueryList" />
    </el-card>
    <!-- 新建表单 -->
  </div>
</template>

<script>
import courseScenarioAnswerApi from '@/api/course/courseScenarioAnswer'
import Pagination from '@/components/Pagination'

export default {
  components: {
    Pagination,
  },
  data() {
    return {
      list: [],
      total: 0,
      listLoading: true,
      query: {
        pageNo: 1,
        pageSize: 10,
        answerType: 5,
        name: undefined,
        isEnable: undefined
      },
      selectItems: [],
      activeName: '0'
    }
  },
  created() {
    this.doQueryList({ pageNo: 1 })
  },
  methods: {
    handleFilter() {
      this.query = {}
      this.query.answerType = 5
      this.doQueryList({ pageNo: 1, pageSize: 10 })
    },
    handleClick() {
      this.doQueryList({ pageNo: 1 })
    },
    /**
     * 选择框变化
     */
    selectionChange(val) {
      this.selectItems = val
    },
    /**
     * 触发后端排序
     */
    sortChange({ prop, order }) {
      const sortKeyMap = {
        'createdTime': 'createdTimeSortSign',
        'operatedTime': 'operatedTimeSortSign'
      }
      for (var k in sortKeyMap) {
        const sortKey = sortKeyMap[k]
        if (k !== prop) {
          this.query[sortKey] = null
        } else {
          if (order === 'ascending') {
            this.query[sortKey] = 1
          } else {
            this.query[sortKey] = -1
          }
        }
      }
      this.doQueryList({})
    },
    /**
     * 触发搜索操作
     */
    handleQuery() {
      this.doQueryList({ pageNo: 1 })
    },
    /**
     * 执行列表查询
     */
    doQueryList({ pageNo, pageSize }) {
      if (pageNo) {
        this.query.pageNo = pageNo
      }
      if (pageSize) {
        this.query.pageSize = pageSize
      }
      this.query.state = +this.activeName
      this.listLoading = true
      return courseScenarioAnswerApi.fetchList(this.query)
        .then(data => {
          this.list = data.data.list
          this.total = data.data.total
        })
        .finally(() => {
          this.listLoading = false
        })
    },
    handleState(row, type) {
      if (type === 1) {
        this.$common.confirm('确认合格？').then(() => courseScenarioAnswerApi.audit({ id: row.id, state: type }))
          .then(() => {
            this.$common.showMsg('success', '操作成功')
            return this.doQueryList({ pageNo: 1 })
          })
      } else {
        this.$prompt('确认不合格？', {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          inputPlaceholder: "请输入不合格原因",
          // inputErrorMessage: '请输入不合格原因',
          // inputValidator: (value) => {
          //   if (!value) {
          //     return false;
          //   }
          //   return true;
          // }
        }).then(({ value }) => {
          return courseScenarioAnswerApi.audit({ id: row.id, state: type, reason: value });
        }).then(() => {
          this.$common.showMsg('success', '操作成功')
          return this.doQueryList({ pageNo: 1 })
        })
      }
    }
  }
}
</script>
